module.exports = __webpack_public_path__ + "img/home_express.161c6089.webp";